/**
 * Normalize a `callbackUrl` query param into a safe relative path.
 *
 * The 2FA verify pages take `?callbackUrl=...` and redirect to it on success.
 * Without a check, a crafted link could redirect users to an external origin
 * after they complete 2FA on the cito domain — an open-redirect / phishing
 * vector. Anything that isn't a same-origin relative path is replaced with
 * `/`.
 *
 * Allowed: `/`, `/123/sites`, `/auth/setup?foo=bar`.
 * Rejected: `https://evil.com`, `//evil.com`, `/\evil.com`, anything not
 *   starting with `/`.
 */
export function safeCallbackUrl(url: string | undefined | null): string {
  if (!url) return "/";
  if (!url.startsWith("/")) return "/";
  // Reject protocol-relative (//host) and backslash-tricks (/\host) which
  // some browsers normalize into a host change.
  if (url.startsWith("//") || url.startsWith("/\\")) return "/";
  return url;
}
